import React from "react";

const LargeIcon = ({ children }) => {
  return React.cloneElement(children, { height: "24px", width: "24px" });
};

export default LargeIcon;
